import moment from 'moment'
import { fetchCompany } from '@/api/parameters'
import { moneda } from '@/utils/filtros'

export async function generateInvoicingDashboardPdf(payload) {
  const pdfMake = require("pdfmake/build/pdfmake.js")
  const pdfFonts = require("pdfmake/build/vfs_fonts.js")
  pdfMake.vfs = pdfFonts.pdfMake.vfs

  // 1. Datos de la empresa
  let company = payload.company || {}
  try {
    if (!company.name && !company.fantasy) {
      company = await fetchCompany()
    }
  } catch (e) {
    company = {}
  }

  const countryCode = company.country_code || 'cl'
  const companyName = company.fantasy || company.name || 'Runflow ERP'
  const companyRut = company.rut || ''
  const timezone = payload.timezoneName || company.current_time_zone || 'America/Santiago'

  const formatMoney = (val) => moneda(Number(val || 0), countryCode)

  const startDateFormatted = payload.startDate ? moment(payload.startDate).format('DD/MM/YYYY') : 'Histórico Completo'
  const filterLabel = `Terminadas desde: ${startDateFormatted}`

  const now = moment()
  const emissionDate = now.format('DD/MM/YYYY HH:mm')

  const metrics = payload.metrics || {}
  const aging = metrics.agingBuckets || {
    normal: { count: 0, net: 0, net_fmt: '$0', pct: 0 },
    attention: { count: 0, net: 0, net_fmt: '$0', pct: 0 },
    critical: { count: 0, net: 0, net_fmt: '$0', pct: 0 }
  }
  const tacticalInsight = metrics.tacticalInsight || null
  const sellers = payload.sellers || []
  const customers = payload.customers || []
  const workOrders = payload.workOrders || []

  // 2. Tablas Top 5 Vendedores y Clientes
  const sellerRows = [
    [
      { text: '#', style: 'th', alignment: 'center', width: 18 },
      { text: 'EJECUTIVO DE VENTAS', style: 'th', width: '*' },
      { text: 'OTS', style: 'th', alignment: 'center', width: 30 },
      { text: 'DÍAS', style: 'th', alignment: 'center', width: 30 },
      { text: 'IEF', style: 'th', alignment: 'center', width: 32 },
      { text: 'MONTO RETENIDO', style: 'th', alignment: 'right', width: 75 }
    ]
  ]

  if (sellers.length === 0) {
    sellerRows.push([
      { text: 'Sin ejecutivos con OTs pendientes', colSpan: 6, alignment: 'center', color: '#94A3B8', fontSize: 8, margin: [0, 8, 0, 8] },
      {}, {}, {}, {}, {}
    ])
  } else {
    sellers.slice(0, 5).forEach((s, idx) => {
      const isEven = idx % 2 === 0
      sellerRows.push([
        { text: String(idx + 1).padStart(2, '0'), fontSize: 7.5, bold: true, color: '#64748B', alignment: 'center', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: s.seller_name || 'Sin nombre', fontSize: 8, bold: true, color: '#1E293B', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${s.count || 0}`, fontSize: 7.5, alignment: 'center', color: '#475569', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${s.avg_days || 0}d`, fontSize: 7.5, alignment: 'center', color: s.avg_days > 8 ? '#BE123C' : '#475569', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${s.ief_score || 0}%`, fontSize: 7.5, bold: true, alignment: 'center', color: s.ief_score >= 80 ? '#047857' : '#B45309', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: s.total_net_fmt || formatMoney(s.total_net), fontSize: 8, bold: true, color: '#0F172A', alignment: 'right', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' }
      ])
    })
  }

  const customerRows = [
    [
      { text: '#', style: 'th', alignment: 'center', width: 18 },
      { text: 'CLIENTE', style: 'th', width: '*' },
      { text: 'OTS', style: 'th', alignment: 'center', width: 30 },
      { text: 'DÍAS', style: 'th', alignment: 'center', width: 30 },
      { text: 'IEF', style: 'th', alignment: 'center', width: 32 },
      { text: 'MONTO RETENIDO', style: 'th', alignment: 'right', width: 75 }
    ]
  ]

  if (customers.length === 0) {
    customerRows.push([
      { text: 'Sin clientes con OTs pendientes', colSpan: 6, alignment: 'center', color: '#94A3B8', fontSize: 8, margin: [0, 8, 0, 8] },
      {}, {}, {}, {}, {}
    ])
  } else {
    customers.slice(0, 5).forEach((c, idx) => {
      const isEven = idx % 2 === 0
      customerRows.push([
        { text: String(idx + 1).padStart(2, '0'), fontSize: 7.5, bold: true, color: '#64748B', alignment: 'center', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: c.customer_name || 'Sin nombre', fontSize: 8, bold: true, color: '#1E293B', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${c.count || 0}`, fontSize: 7.5, alignment: 'center', color: '#475569', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${c.avg_days || 0}d`, fontSize: 7.5, alignment: 'center', color: c.avg_days > 8 ? '#BE123C' : '#475569', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${c.ief_score || 0}%`, fontSize: 7.5, bold: true, alignment: 'center', color: c.ief_score >= 80 ? '#047857' : '#B45309', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: c.total_net_fmt || formatMoney(c.total_net), fontSize: 8, bold: true, color: '#0F172A', alignment: 'right', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' }
      ])
    })
  }

  // 3. Tabla Completa de OTs Pendientes para Página 2
  const woRows = [
    [
      { text: 'COTIZACIÓN', style: 'th', width: 55 },
      { text: 'N° OT', style: 'th', width: 55 },
      { text: 'CLIENTE', style: 'th', width: '*' },
      { text: 'EJECUTIVO', style: 'th', width: 110 },
      { text: 'TÉRMINO PLANTA', style: 'th', alignment: 'center', width: 75 },
      { text: 'DÍAS MORA', style: 'th', alignment: 'center', width: 55 },
      { text: 'MONTO NETO', style: 'th', alignment: 'right', width: 80 }
    ]
  ]

  if (workOrders.length === 0) {
    woRows.push([
      { text: 'No hay órdenes de trabajo terminadas pendientes de facturación', colSpan: 7, alignment: 'center', color: '#94A3B8', fontSize: 8, margin: [0, 8, 0, 8] },
      {}, {}, {}, {}, {}, {}
    ])
  } else {
    workOrders.forEach((wo, idx) => {
      const isEven = idx % 2 === 0
      const days = Number(wo.days_pending || 0)
      const dayColor = days > 10 ? '#BE123C' : (days > 3 ? '#B45309' : '#047857')

      woRows.push([
        { text: wo.quote_id ? `#${wo.quote_id}` : '—', fontSize: 7.5, color: '#64748B', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `OT-${wo.work_order_id}`, fontSize: 7.5, bold: true, color: '#0284C7', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: wo.customer || 'Sin Cliente', fontSize: 7.5, bold: true, color: '#1E293B', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: wo.seller_name || 'Sin Vendedor', fontSize: 7.5, color: '#475569', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: wo.completed_at || '—', fontSize: 7.5, alignment: 'center', color: '#64748B', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: `${days} días`, fontSize: 7.5, bold: true, alignment: 'center', color: dayColor, fillColor: isEven ? '#F8FAFC' : '#FFFFFF' },
        { text: wo.net_amount_fmt || formatMoney(wo.net_amount), fontSize: 7.5, bold: true, color: '#0F172A', alignment: 'right', fillColor: isEven ? '#F8FAFC' : '#FFFFFF' }
      ])
    })
  }

  // 4. Document Definition
  const dd = {
    pageSize: 'LETTER',
    pageOrientation: 'landscape',
    pageMargins: [28, 22, 28, 22],
    footer: function(currentPage, pageCount) {
      return {
        margin: [28, 0, 28, 0],
        columns: [
          { text: 'RUNFLOW ERP · DASHBOARD DE CAPITAL RETENIDO Y EFECTIVIDAD DTE', fontSize: 7, color: '#94A3B8', bold: true },
          { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', fontSize: 7, color: '#94A3B8', bold: true }
        ]
      }
    },
    content: [
      // ==========================================
      // PÁGINA 1: ONE-PAGER COCKPIT EJECUTIVO
      // ==========================================

      // Cabecera Midnight Slate (#0F172A)
      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                fillColor: '#0F172A',
                border: [false, false, false, false],
                margin: [16, 12, 16, 12],
                columns: [
                  {
                    width: '*',
                    stack: [
                      {
                        text: 'RUNFLOW · SNAPSHOT EJECUTIVO CAPITAL POR FACTURAR',
                        fontSize: 8,
                        bold: true,
                        color: '#00A650',
                        characterSpacing: 1.5,
                        margin: [0, 0, 0, 3]
                      },
                      {
                        text: `${companyName}`,
                        fontSize: 16,
                        bold: true,
                        color: '#FFFFFF',
                        margin: [0, 0, 0, 3]
                      },
                      {
                        text: `${companyRut ? 'RUT: ' + companyRut + '  ·  ' : ''}${filterLabel}`,
                        fontSize: 9,
                        color: '#CBD5E1'
                      }
                    ]
                  },
                  {
                    width: 220,
                    alignment: 'right',
                    stack: [
                      {
                        text: 'CONFIDENCIAL · COMITÉ FINANCIERO',
                        fontSize: 7.5,
                        bold: true,
                        color: '#FCA5A5',
                        margin: [0, 0, 0, 6]
                      },
                      {
                        text: `Emisión: ${emissionDate} hrs`,
                        fontSize: 8,
                        color: '#94A3B8',
                        margin: [0, 0, 0, 2]
                      },
                      {
                        text: `Zona Horaria: ${timezone}`,
                        fontSize: 7.5,
                        color: '#64748B'
                      }
                    ]
                  }
                ]
              }
            ]
          ]
        },
        margin: [0, 0, 0, 10],
        layout: {
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0
        }
      },

      // Fila de 4 KPIs Maestros
      {
        table: {
          widths: ['*', '*', '*', '*'],
          body: [
            [
              {
                fillColor: '#F8FAFC',
                border: [true, true, true, true],
                borderColor: ['#BAE6FD', '#BAE6FD', '#BAE6FD', '#BAE6FD'],
                stack: [
                  { text: 'CAPITAL RETENIDO TOTAL', fontSize: 6.5, bold: true, color: '#0369A1', characterSpacing: 0.5, margin: [10, 8, 10, 2] },
                  { text: metrics.totalNetFmt || '$0', fontSize: 13, bold: true, color: '#0F172A', margin: [10, 0, 10, 2] },
                  { text: `${metrics.totalCount || 0} OTs finalizadas sin DTE`, fontSize: 6.5, color: '#64748B', margin: [10, 0, 10, 8] }
                ]
              },
              {
                fillColor: '#F8FAFC',
                border: [true, true, true, true],
                borderColor: ['#E2E8F0', '#E2E8F0', '#E2E8F0', '#E2E8F0'],
                stack: [
                  { text: 'PROMEDIO DÍAS SIN FACTURAR', fontSize: 6.5, bold: true, color: '#64748B', characterSpacing: 0.5, margin: [10, 8, 10, 2] },
                  { text: `${metrics.avgDaysPending || 0} días`, fontSize: 13, bold: true, color: '#0F172A', margin: [10, 0, 10, 2] },
                  { text: 'Desde cierre real en taller (Meta: ≤ 3d)', fontSize: 6.5, color: '#64748B', margin: [10, 0, 10, 8] }
                ]
              },
              {
                fillColor: '#F8FAFC',
                border: [true, true, true, true],
                borderColor: ['#BBF7D0', '#BBF7D0', '#BBF7D0', '#BBF7D0'],
                stack: [
                  { text: 'ÍNDICE IEF GLOBAL', fontSize: 6.5, bold: true, color: '#15803D', characterSpacing: 0.5, margin: [10, 8, 10, 2] },
                  { text: `${metrics.overallIef || 0}%`, fontSize: 13, bold: true, color: '#047857', margin: [10, 0, 10, 2] },
                  { text: 'Facturado dentro de ≤ 3 días', fontSize: 6.5, color: '#64748B', margin: [10, 0, 10, 8] }
                ]
              },
              {
                fillColor: '#FEF2F2',
                border: [true, true, true, true],
                borderColor: ['#FECACA', '#FECACA', '#FECACA', '#FECACA'],
                stack: [
                  { text: 'CAPITAL EN RIESGO CRÍTICO', fontSize: 6.5, bold: true, color: '#BE123C', characterSpacing: 0.5, margin: [10, 8, 10, 2] },
                  { text: aging.critical ? aging.critical.net_fmt : '$0', fontSize: 13, bold: true, color: '#BE123C', margin: [10, 0, 10, 2] },
                  { text: `${aging.critical ? aging.critical.count : 0} OTs con >10 días sin facturar`, fontSize: 6.5, color: '#E11D48', margin: [10, 0, 10, 8] }
                ]
              }
            ]
          ],
          margin: [0, 0, 0, 8],
          layout: {
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0
          }
        }
      },

      // Matriz de Tiempos de Facturación (Semáforo de Envejecimiento)
      {
        table: {
          widths: ['*', '*', '*'],
          body: [
            [
              {
                fillColor: '#F0FDF4',
                border: [true, true, true, true],
                borderColor: ['#BBF7D0', '#BBF7D0', '#BBF7D0', '#BBF7D0'],
                margin: [8, 6, 8, 6],
                stack: [
                  { text: 'NORMAL (0 A 3 DÍAS)', fontSize: 7, bold: true, color: '#047857' },
                  { text: aging.normal ? aging.normal.net_fmt : '$0', fontSize: 11, bold: true, color: '#047857', margin: [0, 1, 0, 1] },
                  { text: `${aging.normal ? aging.normal.count : 0} OTs · ${aging.normal ? aging.normal.pct : 0}% del capital retenido`, fontSize: 6.5, color: '#065F46' }
                ]
              },
              {
                fillColor: '#FEFCE8',
                border: [true, true, true, true],
                borderColor: ['#FEF08A', '#FEF08A', '#FEF08A', '#FEF08A'],
                margin: [8, 6, 8, 6],
                stack: [
                  { text: 'ATENCIÓN (4 A 10 DÍAS)', fontSize: 7, bold: true, color: '#B45309' },
                  { text: aging.attention ? aging.attention.net_fmt : '$0', fontSize: 11, bold: true, color: '#B45309', margin: [0, 1, 0, 1] },
                  { text: `${aging.attention ? aging.attention.count : 0} OTs · ${aging.attention ? aging.attention.pct : 0}% del capital retenido`, fontSize: 6.5, color: '#78350F' }
                ]
              },
              {
                fillColor: '#FEF2F2',
                border: [true, true, true, true],
                borderColor: ['#FECACA', '#FECACA', '#FECACA', '#FECACA'],
                margin: [8, 6, 8, 6],
                stack: [
                  { text: 'CRÍTICO (>10 DÍAS)', fontSize: 7, bold: true, color: '#BE123C' },
                  { text: aging.critical ? aging.critical.net_fmt : '$0', fontSize: 11, bold: true, color: '#BE123C', margin: [0, 1, 0, 1] },
                  { text: `${aging.critical ? aging.critical.count : 0} OTs · ${aging.critical ? aging.critical.pct : 0}% del capital retenido`, fontSize: 6.5, color: '#881337' }
                ]
              }
            ]
          ]
        },
        margin: [0, 0, 0, 8],
        layout: {
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0
        }
      },

      // Callout de Insight Táctico (si existe)
      ...(tacticalInsight ? [
        {
          table: {
            widths: ['*'],
            body: [
              [
                {
                  fillColor: '#0F172A',
                  border: [true, true, true, true],
                  borderColor: ['#00A650', '#00A650', '#00A650', '#00A650'],
                  margin: [12, 6, 12, 6],
                  columns: [
                    {
                      width: 140,
                      stack: [
                        { text: 'INSIGHT TÁCTICO DEL DÍA', fontSize: 7, bold: true, color: '#00A650', characterSpacing: 1 },
                        { text: tacticalInsight.title || 'Diagnóstico de Cobro', fontSize: 8.5, bold: true, color: '#FDE047', margin: [0, 1, 0, 0] }
                      ]
                    },
                    {
                      width: '*',
                      text: (tacticalInsight.body || '').replace(/<[^>]*>/g, ''),
                      fontSize: 7.5,
                      color: '#E2E8F0',
                      lineHeight: 1.25,
                      margin: [8, 0, 0, 0]
                    }
                  ]
                }
              ]
            ]
          },
          margin: [0, 0, 0, 8],
          layout: {
            paddingLeft: () => 0,
            paddingRight: () => 0,
            paddingTop: () => 0,
            paddingBottom: () => 0
          }
        }
      ] : []),

      // Sección en 2 Columnas: Top Vendedores y Top Clientes
      {
        columns: [
          // Columna 1: Top Vendedores
          {
            width: '*',
            stack: [
              {
                text: 'TOP 5 VENDEDORES CON MAYOR CAPITAL RETENIDO',
                fontSize: 7.5,
                bold: true,
                color: '#0F172A',
                characterSpacing: 0.5,
                margin: [0, 0, 0, 4]
              },
              {
                table: {
                  headerRows: 1,
                  dontBreakRows: true,
                  widths: [18, '*', 28, 28, 30, 70],
                  body: sellerRows
                },
                layout: {
                  hLineWidth: (i) => i === 1 ? 1 : 0.5,
                  vLineWidth: () => 0,
                  hLineColor: (i) => i === 1 ? '#0F172A' : '#E2E8F0',
                  paddingLeft: () => 3,
                  paddingRight: () => 3,
                  paddingTop: () => 2.5,
                  paddingBottom: () => 2.5
                }
              }
            ]
          },
          { width: 14, text: '' },
          // Columna 2: Top Clientes
          {
            width: '*',
            stack: [
              {
                text: 'TOP 5 CLIENTES CON MAYOR CAPITAL RETENIDO',
                fontSize: 7.5,
                bold: true,
                color: '#0F172A',
                characterSpacing: 0.5,
                margin: [0, 0, 0, 4]
              },
              {
                table: {
                  headerRows: 1,
                  dontBreakRows: true,
                  widths: [18, '*', 28, 28, 30, 70],
                  body: customerRows
                },
                layout: {
                  hLineWidth: (i) => i === 1 ? 1 : 0.5,
                  vLineWidth: () => 0,
                  hLineColor: (i) => i === 1 ? '#0F172A' : '#E2E8F0',
                  paddingLeft: () => 3,
                  paddingRight: () => 3,
                  paddingTop: () => 2.5,
                  paddingBottom: () => 2.5
                }
              }
            ]
          }
        ]
      },

      // ==========================================
      // PÁGINA 2: AUDITORÍA DETALLADA DE OTS EN MORA
      // ==========================================
      {
        text: '',
        pageBreak: 'before'
      },
      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                fillColor: '#0F172A',
                border: [false, false, false, false],
                margin: [16, 8, 16, 8],
                columns: [
                  {
                    width: '*',
                    text: 'AUDITORÍA DETALLADA DE ÓRDENES DE TRABAJO PENDIENTES DE FACTURACIÓN',
                    fontSize: 9,
                    bold: true,
                    color: '#FFFFFF',
                    margin: [0, 2, 0, 0]
                  },
                  {
                    width: 220,
                    alignment: 'right',
                    text: `Total: ${metrics.totalCount || 0} OTs  ·  Neto: ${metrics.totalNetFmt || '$0'}`,
                    fontSize: 8,
                    bold: true,
                    color: '#00A650',
                    margin: [0, 2, 0, 0]
                  }
                ]
              }
            ]
          ]
        },
        margin: [0, 0, 0, 8],
        layout: {
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0
        }
      },
      {
        table: {
          headerRows: 1,
          dontBreakRows: true,
          widths: [50, 50, '*', 100, 75, 55, 75],
          body: woRows
        },
        layout: {
          hLineWidth: (i) => i === 1 ? 1 : 0.5,
          vLineWidth: () => 0,
          hLineColor: (i) => i === 1 ? '#0F172A' : '#E2E8F0',
          paddingLeft: () => 4,
          paddingRight: () => 4,
          paddingTop: () => 3,
          paddingBottom: () => 3
        }
      }
    ],
    styles: {
      th: {
        fontSize: 7,
        bold: true,
        color: '#FFFFFF',
        fillColor: '#0F172A',
        margin: [0, 2, 0, 2]
      }
    },
    defaultStyle: {
      font: 'Roboto'
    }
  }

  pdfMake.createPdf(dd).download(`Capital_Retenido_${moment().format('YYYYMMDD_HHmm')}.pdf`)
}
